import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Row } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../../i18next';
import { getCurrencySymbol, transformProductPrice } from '../../../../../utils/CommonUtils';
import { createAdditionalCharge, deleteAdditionalCharge, importAdditionalChargesCSV, loadAdditionalCharges, loadOrderTypes, updateAdditionalCharge } from '../../../../../actions';
import AdditionalChargeModal from './AdditionalChargeModal';
import ImportAdditionalChargesFromCSVModal from './ImportAdditonalChargesFromCSVModal';
import Pagination from 'react-js-pagination';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGING_RANGE } from '../../../../../utils/Constants';

class AdditionalCharges extends Component {

    constructor(props) {
        super(props);

        this.state = {
            additionalCharges: [],
            currentAdditionalCharge: {
                id: -1,
                type: null,
                name: '',
                week: '',
                year: '',
                period: null,
                amount: null,
                createDate: null,
                description: ''
            },
            isAdditionalChargeModalOpen: false,
            isImportFromCSVModalOpen: false,
            additionalChargeIndex: -1,
            currentPageNumber: 0
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.toggleImportFromCSVModal = this.toggleImportFromCSVModal.bind(this);
        this.applyCurrentAdditionalCharge = this.applyCurrentAdditionalCharge.bind(this);
        this.deleteCurrentAdditionalCharge = this.deleteCurrentAdditionalCharge.bind(this);
        this.editAdditionalCharge = this.editAdditionalCharge.bind(this);
        this.importAdditionalChargesFromCSV = this.importAdditionalChargesFromCSV.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    componentDidMount() {
        const restaurantId = this.props.match.params.id;

        this.props.loadAdditionalCharges(restaurantId, 0)
    }

    toggleModal(currentAdditionalCharge, additionalChargeIndex) {
        
        this.setState({
            ...this.state,
            isAdditionalChargeModalOpen: !this.state.isAdditionalChargeModalOpen,
            currentAdditionalCharge: currentAdditionalCharge ? currentAdditionalCharge : {},
            additionalChargeIndex: additionalChargeIndex >= 0 ? additionalChargeIndex : -1
        })
    }

    toggleImportFromCSVModal() {

        this.setState({
            ...this.state,
            isAdditionalChargeModalOpen: false,
            isImportFromCSVModalOpen: !this.state.isImportFromCSVModalOpen,
        })    
    }

    applyCurrentAdditionalCharge(currentAdditionalCharge, restaurantId) {
        let copyOfAdditionalCharges = this.state.additionalCharges;

        if (this.state.additionalChargeIndex >= 0) {

            copyOfAdditionalCharges.map((additionalCharge, index) => {

                if (index === this.state.additionalChargeIndex) {
                    copyOfAdditionalCharges.splice(index, 1, currentAdditionalCharge);
                }
            });
        } else {

            copyOfAdditionalCharges.push(currentAdditionalCharge);
        }

        this.props.createAdditionalCharge(currentAdditionalCharge, () => {
            this.props.loadAdditionalCharges(restaurantId, 0)
            this.setState({
                ...this.state,
                additionalCharges: copyOfAdditionalCharges,
                isAdditionalChargeModalOpen: false,
                additionalChargeIndex: -1 
            });
        })
    }

    editAdditionalCharge(currentAdditionalCharge, restaurantId) {
    
        this.props.updateAdditionalCharge(currentAdditionalCharge, () => {
            this.props.loadAdditionalCharges(restaurantId, 0)
            this.setState({
                ...this.state,
                isAdditionalChargeModalOpen: false
            });
        })
    }

    negativeDecimalsValidation(e) {
        let inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 43 || inputKeyCode == 45 || inputKeyCode == 69
                || inputKeyCode == 101) e.preventDefault();
        }
    }

    deleteCurrentAdditionalCharge(id, restaurantId) {

        this.props.deleteAdditionalCharge(id, () => {
            this.props.loadAdditionalCharges(restaurantId, 0)
            this.setState({
                ...this.state,
                isAdditionalChargeModalOpen: false
            })
        })
        
    }

    importAdditionalChargesFromCSV(restaurantId, file) {
        
        this.props.importAdditionalChargesCSV(restaurantId, file, () => {
            this.props.loadAdditionalCharges(restaurantId, 0)
            this.setState({
                ...this.state,
                isImportFromCSVModalOpen: false
            })
        })
    }

    handlePageChange(pageNumber) {
        const restaurantId = this.props.match.params.id;

        this.setState({
            currentPageNumber: (pageNumber - 1)
        }, () => this.props.loadAdditionalCharges(restaurantId, this.state.currentPageNumber));
    }

    renderEditButton(currentAdditionalCharge, additionalChargeIndex) {

        return (
            <Button disabled={this.props.isMenuuAdmin} onClick={() => this.toggleModal(currentAdditionalCharge, additionalChargeIndex)} color="link" style={{ padding: '0px', fontSize: '16px', height: 'auto'}}>
                {i18n.t('common:buttons.edit')}
            </Button>
        )
    }

    renderPagination() {
        const { flexEnd } = styles;
        const { additionalCharges } = this.props.restaurant;

        return (
            <Col style={flexEnd}>
                <Pagination
                    activePage={additionalCharges && additionalCharges.content ? additionalCharges.number + 1 : null}
                    itemsCountPerPage={DEFAULT_PAGE_SIZE}
                    totalItemsCount={additionalCharges && additionalCharges.content ? additionalCharges.totalElements : null}
                    pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                    itemClass='page-item'
                    linkClass='page-link'
                    onChange={this.handlePageChange}
                />
            </Col>
        );
    }

    renderHeader() {
        const { headerStyle, spaceBetween } = this.props.styles;

        return (
            <div style={headerStyle}>
                <MaterialIcon icon="attach_money" color="#0288d1" size={20} />
                <span style={spaceBetween}>{i18n.t('screens:paymentScreen.additionalCharges')}</span>
            </div>
        );
    }

    renderAdditionalChargesFormRows() {
        const { additionalCharges } = this.props.restaurant;
        
        return additionalCharges && additionalCharges.content ? additionalCharges.content.map((additionalCharge, additionalChargeIndex) => {
           
            return (
                <Row key={additionalChargeIndex} style={{marginTop: '15px'}}>
                    <Col xs={1}>{additionalCharge.id > 0 ? additionalCharge.id : ''}</Col>
                    <Col xs={2}>{additionalCharge.type}</Col>
                    <Col xs={2}>{additionalCharge.name}</Col>
                    <Col xs={2}>{`${additionalCharge.week} / ${additionalCharge.year}`}</Col>
                    <Col xs={2}><span>{transformProductPrice(Number(additionalCharge.amount))}</span><span>{getCurrencySymbol(this.props.restaurant.currency)}</span></Col>
                    <Col xs={2}>{additionalCharge.createdDate}</Col>
                    <Col xs={1} style={{ display: 'flex', justifyContent: 'center', paddingRight: '0px' }}>{this.renderEditButton(additionalCharge, additionalChargeIndex)}</Col>
                </Row>
            )
        }) : null
    }

    renderAdditionalCharges() {
        const { saveBtn } = this.props.styles;
        
        return (
            <Row xs={12} style={{margin: '20px 0px'}}>
                <div style={{display: 'flex', justifyContent: 'flex-end', width: '100%', alignItems: 'center'}}>
                    {/* <p style={{ marginBottom: '0px' }}>{i18n.t('screens:paymentScreen.additionalCharges')}</p> */}
                    <Button disabled={this.props.isMenuuAdmin} color="primary" style={{ display: 'flex', marginRight: '5px' }} onClick={() => this.toggleImportFromCSVModal()}>
                        <span style={{ display: 'flex', alignSelf: 'center' }}><MaterialIcon icon="cloud_download" color="#fff" size={18} /></span>
                        <span style={saveBtn}>{i18n.t('common:buttons.import')}</span>
                    </Button>
                    <Button disabled={this.props.isMenuuAdmin} color="primary" style={{ display: 'flex' }} onClick={() => this.toggleModal()}>
                        <span style={{ display: 'flex', alignSelf: 'center' }}><MaterialIcon icon="add_circle_outline" color="#fff" size={18} /></span>
                        <span style={saveBtn}>{i18n.t('screens:paymentScreen.addAdditionalCharge')}</span>
                    </Button>
                </div>
                <Col style={{ padding: '0px 0px 5px 0px', marginTop: '20px', textAlign: 'center' }}>
                    <Row>
                        <Col xs={1}>{i18n.t('screens:paymentScreen.id')}</Col>
                        <Col xs={2}>{i18n.t('screens:paymentScreen.type')}</Col>
                        <Col xs={2}>{i18n.t('screens:paymentScreen.name')}</Col>
                        <Col xs={2}>{i18n.t('screens:paymentScreen.period')}</Col>
                        <Col xs={2}>{i18n.t('screens:paymentScreen.total')}</Col>
                        <Col xs={2}>{i18n.t('screens:paymentScreen.createDate')}</Col>
                    </Row>
                {this.renderAdditionalChargesFormRows()}
                {this.renderPagination()}
                </Col>
            </Row>
        )
    }

    render() {

        return (
            <div>
                {this.renderHeader()}
                {this.renderAdditionalCharges()}
                { this.state.isAdditionalChargeModalOpen ? 

                    <AdditionalChargeModal
                    {...this.props}
                    isOpen={this.state.isAdditionalChargeModalOpen}
                    toggle={this.toggleModal}
                    currentAdditionalCharge={this.state.currentAdditionalCharge}
                    applyCurrentAdditionalCharge={this.applyCurrentAdditionalCharge}
                    negativeDecimalsValidation={this.negativeDecimalsValidation}
                    deleteCurrentAdditionalCharge={this.deleteCurrentAdditionalCharge}
                    editAdditionalCharge={this.editAdditionalCharge}
                    additionalChargeIndex={this.state.additionalChargeIndex}
                     /> : null
                }
                {
                    this.state.isImportFromCSVModalOpen ? 
                    <ImportAdditionalChargesFromCSVModal
                        {...this.props}
                        isOpen={this.state.isImportFromCSVModalOpen} 
                        toggle={this.toggleImportFromCSVModal}
                        importAdditionalChargesFromCSV={this.importAdditionalChargesFromCSV}
                    /> : null
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        serviceSettingsGeneral: state.serviceSettingsGeneral,
        restaurant: state.restaurant
    }
}

export default connect(mapStateToProps, { 
    getCurrencySymbol,
    loadOrderTypes,
    loadAdditionalCharges,
    createAdditionalCharge,
    deleteAdditionalCharge,
    updateAdditionalCharge,
    importAdditionalChargesCSV
     })(AdditionalCharges);

const styles = {

    cardContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '15px'
    },
    btnStyle: {
        display: 'flex',
        alignSelf: 'center',
        padding: '0px 6px 3px'
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '30px',
        paddingRight: 0
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/menuuBilling/AdditionalCharges.js